const TIME_IN_SECONDS = 1;
const TIME_IN_MINUTES = 60 * TIME_IN_SECONDS;
const TIME_IN_HOURS = 60 * TIME_IN_MINUTES;
const TIME_IN_DAYS = 24 * TIME_IN_HOURS;
const TIME_IN_WEEKS = 7 * TIME_IN_DAYS;
const TIME_IN_MONTHS = 30 * TIME_IN_DAYS;
const TIME_IN_YEARS = 365 * TIME_IN_DAYS;

/** Largest unit first: the first one the elapsed time reaches is the one shown. */
const UNITS = [
  ['year', TIME_IN_YEARS],
  ['month', TIME_IN_MONTHS],
  ['week', TIME_IN_WEEKS],
  ['day', TIME_IN_DAYS],
  ['hour', TIME_IN_HOURS],
  ['minute', TIME_IN_MINUTES],
];

/**
 * Converts a date into a compact relative string in the given language, via
 * `Intl.RelativeTimeFormat` — "5m ago" / "hace 5 min", "3d ago" / "hace 3 d".
 * Under a minute reads "now" / "ahora".
 */
const timeAgo = (input, locale = 'en') => {
  if (!input) return null;

  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return null;

  const diffSeconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  const unit = UNITS.find(([, seconds]) => diffSeconds >= seconds);

  if (!unit) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(0, 'second');
  }

  const [name, seconds] = unit;
  return new Intl.RelativeTimeFormat(locale, { numeric: 'always', style: 'narrow' })
    .format(-Math.floor(diffSeconds / seconds), name);
};

export default timeAgo;
